<div class="table-flex text-xs w-100">
    <div class="thead">
        <div class="trow text-darkest font-medium text-xs">
            <!-- Checkbox -->
            <div class="tcell cell-checkbox shrink ps-0 pt-0">
                <app-form-checkbox-deprecated
                    [ariaLabelText]="'v3-company-admin-support-popup' | translate"
                    *ngIf="selectFormControl"
                    [formControl]="selectFormControl"
                    [size]="'lg'"
                ></app-form-checkbox-deprecated>
            </div>
            <!-- Name -->
            <div class="tcell grow cell-name grow text-left ps-0 pt-0 pe-2" translate>v3-user-management-index-table-th-name</div>
            <!-- Country -->
            <div class="tcell grow cell-country grow text-left ps-0 pt-0 pe-2 flex-wrap">
                <span translate>v3-company-admin-support-popup-country</span>/<span translate>v3-company-admin-support-popup-region</span>
            </div>
            <!-- Email -->
            <div class="tcell grow cell-email grow text-left ps-0 pt-0" translate>v3-global-email</div>
        </div>
    </div>
</div>
